<template>
    <div v-if="widgetReady">
        <h3>Group Contributions</h3>
        <div v-if="!planCategories.length" class="alert alert-warning">
            There are currently no plans available for contribution.
        </div>
        <div v-else class="info-board info-board-blue">
            <label v-if="this.company.isFamilyContribution">
                Enter a total monthly contribution amount that will be shared across the whole family. <br/>
                * Once a change is made, additional changes are not allowed until the pending change takes effect.
            </label>
            <label v-else>
                Enter monthly contribution amounts for each family member type.<br>
                * Once a change is made, additional changes are not 
                allowed until the pending change takes effect.
            </label>
        </div>
        <div v-for="category in planCategories" class="form-group" :key="category.id">
            <hr>
            <employer-contribution :companyId="companyId" 
                :planCategoryId="category.id" 
                :defaultEffDate="defaultEffDate"
                @contribution-updated="contributionUpdated">
                
            </employer-contribution>
        </div>
    </div>
</template>

<script>
    import {api} from "../../../global/framework/api.js";
    import EmployerContribution from "./EmployerContribution.vue";

    export default {
        name: "EmployerContributions",
        components: {EmployerContribution},
        props: {
            companyId: {type: [Number], required: true}, 
            defaultEffDate: {type: [Object], required: false, default: null}},
        data() {
            return {
                widgetReady: false,
                planCategories: [],
                company: {}
            }
        },
        async mounted() {
            var [categories, company] = await Promise.all([api.get("Company", this.companyId, "GetPlanCategories"), api.get('Company', this.companyId, 'GetCompanyById')]);
            this.planCategories = categories;
            this.company = company;
            this.widgetReady = true;
        },
        methods: {
            contributionUpdated(categoryId) {
                this.$emit('contributions-updated', categoryId);
            }
        },
    }

</script>

<style scoped>

</style>